import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive: string;
}

const MENUITEMS = [
  {
    state: "dashboard",
    name: "Dashboard",
    type: "link",
    iconUrl: "assets/images/dashboard_black.svg",
    iconUrlActive: "assets/images/dashboadIcon.svg",
    access: "users",
  },
  {
    state: "profile",
    name: "Manage Profile",
    iconUrl: "assets/images/ic_user1.svg",
    type: "link",
    iconUrlActive: "assets/images/ic_user1_active.svg",
    access: "users",
  },

  // { state:'analytic', name: 'Analytics', type: 'link', icon: 'insert_chart_outlined', iconColor: '#FF5959', show: true },
  // { state: 'map', type: 'link', name: 'Map View',iconUrl: 'assets/images/ic_map.svg',iconUrlActive: 'assets/images/ic_map_active.svg', access: 'users' },
  // {
  //   state: "user-management",
  //   type: "link",
  //   name: "Users",
  //   iconUrl: "assets/images/ic_user.svg",
  //   iconUrlActive: "assets/images/ic_user_active.svg",
  //   access: "users",
  // },
  //  { state: 'roles', type: 'link', name: 'Roles', iconUrl: 'assets/images/ic_role.svg',iconUrlActive: 'assets/images/ic_role_active.svg', access: 'roles' },

  //  { state: 'driver-management', type: 'link', name: 'Drivers',iconUrl: 'assets/images/ic_driver.svg',iconUrlActive: 'assets/images/ic_driver_active.svg', access: 'drivers' },
  // state: 'order', type: 'link', name: 'Order',iconUrl: 'assets/images/ic_order.svg',iconUrlActive: 'assets/images/ic_order_active.svg', access: 'drivers' },
  //  { state: 'fare', type: 'link', name: 'Manage Fare',iconUrl: 'assets/images/ic_fare.svg',iconUrlActive: 'assets/images/ic_fare_active.svg', access: 'users' },
  {
    state: "promo",
    type: "link",
    name: "Manage Coupon",
    iconUrl: "assets/images/ic_promo.svg",
    iconUrlActive: "assets/images/ic_promo_active.svg",
    access: "users",
  },
  {
    state: "order",
    type: "link",
    name: "Manage Order",
    iconUrl: "assets/images/ic_order.svg",
    iconUrlActive: "assets/images/ic_order_active.svg",
    access: "drivers",
  },
  //  { state: 'banner', type: 'link', name: 'Manage Banner',iconUrl: 'assets/images/ic_banner1.svg',iconUrlActive: 'assets/images/ic_banner1_active.svg', access: 'users' },
  //  { state: 'pickdrop', type: 'link', name: 'Pick & Drop Service',iconUrl: 'assets/images/ic_pickdrop.svg',iconUrlActive: 'assets/images/ic_pickdrop_active.svg', access: 'users' },
  //  { state: 'merchant', type: 'link', name: 'Manage Merchant',iconUrl: 'assets/images/ic_merchant.svg',iconUrlActive: 'assets/images/ic_merchant_active.svg', access: 'users' },
  {
    state: "menu",
    type: "link",
    name: "Manage Menu",
    iconUrl: "assets/images/ic_menu.svg",
    iconUrlActive: "assets/images/ic_menu_active.svg",
    access: "users",
  },
  {
    state: "category",
    type: "link",
    name: "Manage Category",
    iconUrl: "assets/images/ic_list.svg",
    iconUrlActive: "assets/images/ic_list_active.svg",
    access: "users",
  },
  {
    state: "banner",
    type: "link",
    name: "Manage Banner",
    iconUrl: "assets/images/Banner.svg",
    iconUrlActive: "assets/images/Banner_white.svg",
    access: "users",
  },
  {
    state: "rating",
    type: "link",
    name: "Rating",
    iconUrlActive: "assets/images/ic_rating_white.svg",
    iconUrl: "assets/images/ic_rating_black.svg",
    access: "users",
  },
  
];

@Injectable()
export class MenuItems {
  constructor(private commonService: CommonService) {}
  getMenuitem(): Menu[] {
    const menuItems = MENUITEMS;
    menuItems.forEach((element) => {
      if (element.hasOwnProperty("access")) {
        const perm = this.commonService.getPermissions(element.access);
        element["show"] = perm !== "H";
      }
    });
    return menuItems;
  }
}
